import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createFaqsSaga } from "src/store/web-faqs/saga";
import * as Yup from "yup";

const FaqsCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Faqs.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Question: "",
          ShowWeb: false,
          ShowMobileApp: false,
          Answer: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Question: "", Answer: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createFaqsSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Answer: Yup.string().required(t("Validation.Required").toString()),
          Question: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Question: Yup.string().required(
                t("Validation.Required").toString()
              ),
              Answer: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Question",
            label: t("Faqs.Question").toString(),
            type: "textarea",
          },
          {
            field: "Answer",
            label: t("Faqs.Answer").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "ShowApp",
            label: t("Faqs.ShowApp").toString(),
            type: "switch",
            col: 6,
          },
          {
            field: "ShowWeb",
            label: t("Faqs.ShowWeb").toString(),
            type: "switch",
            col: 6,
          },
        ]}
      />
    </React.Fragment>
  );
};
export default FaqsCreateForm;
